import { render, staticRenderFns } from "./OrderCancellation.vue?vue&type=template&id=1250f0f4&scoped=true&"
import script from "./OrderCancellation.vue?vue&type=script&lang=js&"
export * from "./OrderCancellation.vue?vue&type=script&lang=js&"
import style0 from "./OrderCancellation.vue?vue&type=style&index=0&id=1250f0f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1250f0f4",
  null
  
)

export default component.exports